import IGridicsUseTag = ZoneIQCalibration.IGridicsUseTag;
import { GridicsUseTagModel } from 'src/app/models/common-models/gridics-use-tag.model';
import { IMapper } from 'src/app/interfaces/mappers/mapper';
import { SimpleMapper } from './simple-mapper';

export class GridicsUseTagMapper extends SimpleMapper<GridicsUseTagModel, IGridicsUseTag> {
    constructor() {
        super();
        this.fromDTOFields = ['Id', 'GridicsUse', 'CalibrationUsesTypeId', 'CreatedOn', 'ModifiedOn'];
        this.toDTOFields = ['Id', 'GridicsUse', 'CalibrationUsesTypeId', 'CreatedOn', 'ModifiedOn'];
        this.entityConstructor = GridicsUseTagModel;
    }
}

export function gridicsUseTagMapperFactory(): IMapper<GridicsUseTagModel, IGridicsUseTag> {
    return new GridicsUseTagMapper();
}
